import "./styles.scss";
import { useEffect } from "react";
import PrismCode from "react-prism";
import "prismjs";
import "prismjs/components/prism-jsx.min";
import Avatar from "../../assets/logo-color.png";
import QCCourse from "./component/QCCourse";
import { Helmet } from "react-helmet";

const block1 = `function foo() {
  // The function scope
  let count = 0;
  console.log(count); // logs 0
}

foo();
console.log(count); // ReferenceError: count is not defined`;

const block2 = `function foo() {
  // "foo" function scope
  let count = 0;
  console.log(count); // logs 0
}

function bar() {
  // "bar" function scope
  let count = 1;
  console.log(count); // logs 1
}

foo();
bar();`;

const block3 = `function outerFunc() {
  // the outer scope
  let outerVar = 'I am outside!';

  function innerFunc() {
    // the inner scope
    console.log(outerVar); // => logs "I am outside!"
  }

  innerFunc();
}

outerFunc();`;

const block4 = `// Scope A
var myFunction = function () {
  // Scope B
  var name = 'DevFE'; // định nghĩa trong Scope B
  var myOtherFunction = function () {
    // Scope C: "name"vẫn có thể được truy cập đến từ đây!!
  };
};`;

const block5 = `var myFunction = function () {
  var name = 'Duy';
  var myOtherFunction = function () {
    console.log('My name is ' + name);
  };
  console.log(name);
  myOtherFunction(); // call function
};

// 'Devfe'
// 'My name is Devfe'`;

const block7 = `function outerFunc() {
  let outerVar = 'I am outside!';

  function innerFunc() {
    console.log(outerVar); // => logs "I am outside!"
  }

  return innerFunc;
}

function exec() {
  const myInnerFunc = outerFunc();
  myInnerFunc();
}

exec();
`;

const block8 = `let countClicked = 0;

myButton.addEventListener('click', function handleClick() {
  countClicked++;
  myText.innerText =countClicked;
});`;
const block9 = `const message = 'Hello, World!';

setTimeout(function callback() {
  console.log(message); // logs "Hello, World!"
}, 1000);`;
const block10 = `let countEven = 0;
const items = [1, 5, 100, 10];

items.forEach(function iterator(number) {
  if (number % 2 === 0) {
    countEven++;
  }
});

countEven; // => 2`;

const block11 = `function Counter() {
  let count = 0;

  function add() {
    count++;
    return count
  }

  return add;
}

const counter = Counter()
console.log(counter()) // 1
console.log(counter()) // 2
console.log(counter()) // 3
;`
export default function BlogClosureForBeginner() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const canvas = document.querySelector("canvas");
    canvas.remove();
    return () => {
      const para = document.createElement("canvas");
      para.className = "canvas-bg";
      document.getElementsByClassName("app")[0].appendChild(para);
    };
  }, []);

  return (
    <div className="wrapper blog-detail-wrapper">
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="devfe-blog, Bỏ túi Closure trong Javascript chỉ với 5 phút, tìm hiểu cơ bản về closure, áp dụng closure đối với thực tế sẽ như thế nào"
        />
        <title>Bỏ túi Closure trong Javascript chỉ với 5 phút</title>
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://devfe-edu.netlify.app/blog/authentication-google-voi-react"
        />
        <meta property="og:title" content="Bỏ túi Closure chỉ với 5 phút" />
        <meta
          property="og:description"
          content="devfe-blog, Bỏ túi Closure trong, tìm hiểu cơ bản về closure, áp dụng closure đối với thực tế sẽ như thế nào"
        />
        <meta
          property="og:image"
          content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfYd2ExX15sNev8dYlsnqlTnfPm-cbkwlWaA&usqp=CAU"
        />
                <meta
      property="twitter:image"
      content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfYd2ExX15sNev8dYlsnqlTnfPm-cbkwlWaA&usqp=CAU"
    />
    <meta
      property="og:image"
      content="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfYd2ExX15sNev8dYlsnqlTnfPm-cbkwlWaA&usqp=CAU"
    />
    <link
    rel="shortcut icon"
    href="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfYd2ExX15sNev8dYlsnqlTnfPm-cbkwlWaA&usqp=CAU"
    type="image/x-icon"
  />
      </Helmet>
      <article className="article-content">
        <header>
          <h1>Bỏ túi Closure trong Javascript chỉ với 5 phút</h1>
          <span>
            June 25, 2023 <span className="tag-course">Javascript</span>
          </span>
          <a
            className="information-author"
            href="https://www.tiktok.com/@devfe68"
          >
            <div className="avatar">
              <img src={Avatar} alt="avatar-author" />
            </div>
            <h3>DevFE</h3>
          </a>
          <QCCourse />
          <div className="key-hightlight">
            <h3 className="title-blog">Nội dung chính</h3>
            <ul>
              <li>Closure là gì</li>
              <li>Scope trong javascript</li>
              <li>Thực tế closure dùng để làm gì</li>
            </ul>
            <div className="bg-key">
              <img
                src="https://global-uploads.webflow.com/6336e79cd8d43cd4d1230849/63de59bc2ae9b097edc04479_hedgie_banner%201-min.png"
                alt=""
              />
            </div>
          </div>
        </header>

        <main>
          <p className="content-blog">
            CallBack, Event handler, higher-order functions có thể truy cập các
            biến phạm vi bên ngoài đều là nhờ Closure. Khái niệm Closure trong
            functional và 100% phỏng vấn đều có câu hỏi liên quan về closure nhé
            anh em 🤯.
            <br />
            Có thể bạn đang sử dụng Closure mà bạn chưa biết, hoặc có thể bạn đã
            hiểu, nhưng trong 1 số khoảng khắc bạn bạn thốt lên "what, Closure
            là cái quái gì" thì đây chính là bài biết dành riêng cho bạn.
            <br />
            Chúng ta sẽ bắt đầu từ những thuật ngữ cơ bản: Scope, lexical scope.
            <br />
            Trước khi bắt đầu, nếu bạn còn chưa vững chắc về HTML, CSS,
            Javascript thì bạn có thể đến với khoá học Frontend từ cơ bản đến
            nâng cao của mình nhé !
            <br />
            Thôi, Start nào !!! 👇
          </p>
          <h3 className="title-blog">1. Scope là gì</h3>
          <p className="content-blog">
            Khi bạn tạo 1 biến, bạn chỉ muốn nó được sử dụng trong một khu vực
            nào đó thôi. VD: bạn khai báo 1 biến trong hàm calculate() thì ở
            ngoài hàm calculate bạn sẽ không thể truy cập đến biến đó. Khả năng
            truy cập đến 1 biến được gọi là scope. bạn có thể truy cập đến nó
            nếu bạn đang trong scope của biến đó và sẽ không truy cập được nếu
            bạn đang nằm ngoài scope của biến. Và trong script 1 scope nó được
            tạo bởi 1 function, một block code.
            <br />
            Ví dụ dưới, Biến Count được tạo bên trong func Foo và chính Foo là
            scope của nó.
            <PrismCode
              component="pre"
              className="language-js"
              children={block1}
            />
            Count chỉ được truy cập trong scope của nó, là Foo. Như đã nói thì
            ngoài scope không thể truy cập được Count vì vậy khi mình log Count
            ngoài Func Foo thì nó báo lỗi. Wow, dễ mà đúng không, nói đơn giản,
            scope của 1 biến là phạm vi mà có thể truy cập được biến đó.
            <img
              src="https://dmitripavlutin.com/dce1a2254c5011e2f61cb4d0390b30fe/javascript-scope-3.svg"
              alt="scope-variable"
            />
            <br />
            từ đó, chúng ta lại sinh ra 1 khái niệm mới: the scope isolates
            variables (phạm vi cô lập các biến), yes như nghĩa của nó, scope nó
            cũng sẽ cô lập các biến đó trong 1 block, 1 func vì vậy chúng ta có
            thể sử dụng lại tên các biến đó ở 1 scope khác. ví dụ:
            <PrismCode
              component="pre"
              className="language-js"
              children={block2}
            />
            scope foo() và bar() đều có biến Count và nó vẫn work ngon :v
          </p>
          <h3 className="title-blog">2. Scopes nesting</h3>
          Thêm ví dụ nữa về scope xem là anh em hiểu chưa nhé 😂. Mình có 1 func
          outsideFunc() và func innerFunc() được lồng trong outerFunc. Theo bạn,
          mình có thể truy cập biến outsideVar của outsideFunc ở trong
          innerFunc() được ko 🤯
          <p className="content-blog">
            <PrismCode
              component="pre"
              className="language-js"
              children={block3}
            />
            Đúng vậy, ở innerFunc có thể truy cập đến outsideVar. vì Thật vậy,
            biến outsideVar có thể truy cập được bên trong phạm vi innerFunc().
            Vì các biến của scope ngoài có thể truy cập được biến từ scope bên
            trong.
            <img
              src="https://dmitripavlutin.com/fbdde096ed09128accae5cf39a391587/javascript-nested-scopes-3.svg"
              alt="scope-variable"
            />
            Có 2 điều thú vị ở Scope mà bạn cần phải biết:
            <ul>
              <li>Các scope có thể lồng nhau</li>
              <li>
                Các biến của scope ngoài có thể truy cập từ phạm vi bên trong
              </li>
            </ul>
          </p>
          <h3 className="title-blog">3. The lexical scope</h3>
          <p className="content-blog">
            Khi nhìn thấy một function nằm trong một function khác, function
            trong có quyền truy cập tới scope của function bên ngoài, đó gọi là
            Lexical Scope hay Static Scope.
            <br />
            VD:
            <PrismCode
              component="pre"
              className="language-js"
              children={block4}
            />
            Ở đây có thể nhận thấy rằng, myOtherFunction mới chỉ được định nghĩa
            chứ chưa được gọi. Thứ tự gọi cũng có ảnh hưởng đến các biến:
            <PrismCode
              component="pre"
              className="language-js"
              children={block5}
            />
          </p>
          <h3 className="title-blog">4. The closure</h3>
          <p className="content-blog">
            Đi vòng nãy giờ thì cũng đến phần quan trọng rồi. Chúng ta cùng xem
            lại ví dụ về outsideFunc() và innerFunc() và có thay đổi 1 xíu nhé.
            innerFunc() được gọi bên ngoài lexical scope của nó, trong hàm
            exec(). innerFunc() vẫn có thể truy cập outerVar chứ?
            <br />
            VD:
            <PrismCode
              component="pre"
              className="language-js"
              children={block7}
            />
            Giờ đây, innerFunc() được thực thi bên ngoài lexical scope của nó,
            chính xác là trong scope exec(). Và điều quan trọng: innerFunc() vẫn
            có quyền truy cập vào outerVar từ lexical scope của nó, thậm chí
            được thực thi bên ngoài lexical scope của nó. Nói cách khác,
            innerFunc() nắm bắt, ghi nhớ biến outerVar khỏi lexical scope của
            nó, còn có thể gọi innerFunc() là closure vì nó lưu giữa biến
            outerVar từ lexical scope của nó.
            <img
              src="https://dmitripavlutin.com/abb81d8f5ca936ad83074e72cabf1d19/javascript-closure-6.svg"
              alt="closure-variable"
            />
            Vậy Closure là một hàm truy cập lexical scope của nó và thậm chí
            được thực thi bên ngoài lexical scope của nó. hơi mù mờ nhỉ, nhưng
            hãy hiểu đơn giản. Closure là 1 hàm ghi nhớ các biến nơi mà nó được
            khai báo, bất kể nó được thực thi ở đâu. Tìm hiểu Closure là gì rồi,
            nhưng cùng xem là nó có ích gì trong những ví dụ thường ngày.
          </p>
          <h3 className="title-blog">5. Ví dụ về closure</h3>
          <h4 className="subtitle-blog">5.1 Event handler</h4>
          <p className="content-blog">
            <PrismCode
              component="pre"
              className="language-js"
              children={block8}
            />
            Khi Button đc click, handleClick() được thực thi ở đâu đó DOM. Việc
            thực hiện xảy chắc chắn không nằm trong lexical scope của nó rồi nhỉ
            :v . Nhưng là Closure, handleClick() lưu giữ countClicked từ lexical
            scope và cập nhật nó khi click.
          </p>
          <h4 className="subtitle-blog">5.2 Callbacks</h4>
          <p className="content-blog">
            Ở một hàm setTimeout:
            <PrismCode
              component="pre"
              className="language-js"
              children={block9}
            />
            callback là 1 closure vì nó lưu lại message. Ví dụ cho 1 vòng lặp
            forEach().
            <PrismCode
              component="pre"
              className="language-js"
              children={block10}
            />
          </p>
          <h4 className="subtitle-blog">5.3 Encapsulation</h4>
          <p className="content-blog">
            Một ứng dụng xịn xò nữa là khả năng đóng gói.
            <PrismCode
              component="pre"
              className="language-js"
              children={block11}
            />
          </p>
          Đọc đi đọc lại để hiểu rõ hơn về Closure hay không, hãy ôn kĩ để có một tâm lí thật tốt khi đi phỏng vấn nhé, 
          nếu bạn thấy hãy cho mình 1 follow ở page và tài khoản tiktok nhé 😍
          <p className="footer-blog">
            Chúc bạn có một ngày vui vẻ - happly coding - nếu có hứng thú, bạn
            có thể xem thêm những video của tôi tại kênh tiktok&nbsp;
            <a
              href="https://www.tiktok.com/@devfe68"
              target="_blank"
              rel="noreferrer"
            >
              @devfe68
            </a>
          </p>
        </main>
      </article>

      <div className="header-background"></div>
    </div>
  );
}
